const demoData = (range) => {
  const demo = {
    data: [
      {
        x: ' . ',
        y: range,
        entryType: ''
      },
      {
        x: ' .. ',
        y: range,
        entryType: ''
      }
    ]
  };

  return demo;
};
export { demoData };
